import { render, staticRenderFns } from "./LevelDialog.vue?vue&type=template&id=906cfe2c&scoped=true&"
import script from "./LevelDialog.vue?vue&type=script&lang=js&"
export * from "./LevelDialog.vue?vue&type=script&lang=js&"
import style0 from "./LevelDialog.vue?vue&type=style&index=0&id=906cfe2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906cfe2c",
  null
  
)

export default component.exports